import { useCallback } from 'react'

export function useIframePostMessage() {
  const postMessage = useCallback((params) => {
    window.parent.postMessage(params, '*')
  }, [])
  return {
    postMessage
  }
}
